module.exports = "<kt-splash-screen *ngIf=\"loader\"></kt-splash-screen>\r\n<ngx-ui-loader></ngx-ui-loader>\r\n<router-outlet></router-outlet>\r\n"